import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProfileService } from 'src/app/services/profile.service';
import { IsValidMobile, IsValidEmail } from 'src/app/validation';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss', './../ifacss.scss']
})
export class ContactComponent implements OnInit {
  mailtext: any;
  footercontacttext: any;
  footeraddresstext: any;
  LetsTalkForm: FormGroup;
  subBrokerID_mail: string;
  dataSource: any;
  scheduleofcall: any;
  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService
  ) {
    this.LetsTalkForm = this.fb.group({
      customer_name: ['', [Validators.required]],
      Mobile_No: ['', [Validators.required, Validators.pattern(IsValidMobile)]],
      customer_Email: [
        '',
        [Validators.required, Validators.pattern(IsValidEmail)]
      ],
      Statein: ['', [Validators.required]],
      city_name: ['', [Validators.required]],
      customer_Meassage: ['', [Validators.required]],
      talk_schedule1: ['', []]
    });
  }
  get f() {
    return this.LetsTalkForm.controls;
  }
  ngOnInit(): void {
    this.mailtext = sessionStorage.getItem('ihjt45h45=j');
    this.footercontacttext = sessionStorage.getItem('ihjt45h45=m');
    this.footeraddresstext = sessionStorage.getItem('ihjt45h45=n');
    this.subBrokerID_mail = sessionStorage.getItem('ihjt45h45=sb');
  }
  onsubmitLetsTalkForm() {
    this.LetsTalkForm.controls['talk_schedule1'].setValue(this.scheduleofcall);
    if (this.LetsTalkForm.invalid) {
      return;
    } else {
      const json = {
        customer_name: this.LetsTalkForm.controls['customer_name'].value,
        Mobile_No: this.LetsTalkForm.controls['Mobile_No'].value,
        customer_Email: this.LetsTalkForm.controls['customer_Email'].value,
        Statein: this.LetsTalkForm.controls['Statein'].value,
        city_name: this.LetsTalkForm.controls['city_name'].value,
        customer_Meassage:
          this.LetsTalkForm.controls['customer_Meassage'].value,
        talk_schedule1: this.LetsTalkForm.controls['talk_schedule1'].value,
        S_Brokerid: this.subBrokerID_mail
      };
      let DataBody = JSON.stringify(json);
      this.profileService
        .PostMailToMFLetstalkform(DataBody)
        .subscribe((result: any) => {
          this.dataSource = result;

          //this.CallAlertModalProfile(this.dataSource.ArrayOfResponse[0].message);

          this.LetsTalkForm.controls['customer_name'].setValue('');
          this.LetsTalkForm.controls['Mobile_No'].setValue('');
          this.LetsTalkForm.controls['customer_Email'].setValue('');
          this.LetsTalkForm.controls['Statein'].setValue('');
          this.LetsTalkForm.controls['city_name'].setValue('');
          this.LetsTalkForm.controls['customer_Meassage'].setValue('');
          this.LetsTalkForm.controls['talk_schedule1'].setValue('');
        });
    }
  }
  Scheduletimecall(e) {
    this.scheduleofcall = e.target.value;
  }
}
